exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-data-bank-dataset-detail-___dataset-detail__modalContainer___1KhEH {\n  height: 80%;\n  max-height: 80% !important;\n  width: 750px;\n  max-width: 750px;\n}\n\n.src-components-data-bank-dataset-detail-___dataset-detail__datasetDetail___2A8nH {\n  width: 750px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: white;\n}\n\n#src-components-data-bank-dataset-detail-___dataset-detail__dataset-detail-modal___1sJ16 {\n  background: white;\n  max-width: 750px !important;\n  overflow-x: auto;\n}\n\n@media screen and (max-width: 750px) {\n  .src-components-data-bank-dataset-detail-___dataset-detail__modalContainer___1KhEH {\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n\n  .src-components-data-bank-dataset-detail-___dataset-detail__datasetDetail___2A8nH {\n    width: 100%;\n  }\n}", ""]);

// exports
exports.locals = {
	"modalContainer": "src-components-data-bank-dataset-detail-___dataset-detail__modalContainer___1KhEH",
	"datasetDetail": "src-components-data-bank-dataset-detail-___dataset-detail__datasetDetail___2A8nH",
	"dataset-detail-modal": "src-components-data-bank-dataset-detail-___dataset-detail__dataset-detail-modal___1sJ16"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/data-bank/dataset-detail/dataset-detail.scss
// module id = 2260
// module chunks = 0